import { SpiritualStage } from "../generated/api-client";

export const spiritualStageValues: SpiritualStage[] = [
    "New",
    "Baptised",
    "Adopted",
    "Sealed",
];

export const spiritualStageLabels: Record<SpiritualStage, string> = {
    New: "Alma Nueva",
    Baptised: "Bautizado/a",
    Adopted: "Adoptado/a",
    Sealed: "Sellado/a",
};

export const spiritualStageOptions = spiritualStageValues.map(value => ({
    value,
    label: spiritualStageLabels[value],
}));
